<template>
  <b-container class="wrap-category">
    <Title :main="titleName" :des="descName" />
    <b-row class="box-btn">
      <b-col v-for="(btn, i) in btnsx" :key="i" cols="12" md="6" class="col">
        <a :href="btn.link" target="_blank">
          <div>{{ btn.title }}</div>
        </a>
      </b-col>
    </b-row>
    <b-row>
      <b-col v-for="category in categoriesList" :key="category.id" @click.prevent="clickToDetail(category.id)" cols="12"
        md="3">
        <Card :data="category" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'
import { constantsComputed } from '@/store/helpers'

const Title = () => import('@/components/About/Parts/Title')
const Card = () => import('./Card')

export default {
  components: {
    Title,
    Card
  },

  computed: {
    ...constantsComputed,
    ...mapState({
      categoriesList: state => state.awards.categoriesList,
      links: state => state.awards.links
    }),
    yearText () {
      const mConfig = this.configMap.get('yearConfig')
      return mConfig ? mConfig.name : 2023
    },
    titleName () {
      const mConfig = this.configMap.get('categories_title')
      return mConfig ? mConfig.name : 'J U D G E S'
    },
    descName () {
      const mConfig = this.configMap.get('categories_desc')
      return mConfig ? mConfig.name : `ADMAN AWARDS JUDGES ${this.yearText}`
    },
    btnEntry () {
      const mConfig = this.configMap.get('downloadFullEntryKit')
      return mConfig
    },
    btnEndorsement () {
      const mConfig = this.configMap.get('downloadClientEndorsementForm')
      return mConfig
    },
    btnsx () {
      return this.btns
        .map(btn => {
          const mConfig = this.configMap.get(btn.key)

          if (mConfig) {
            btn.isDisplay = mConfig.isDisplay
            btn.title = mConfig.name ? mConfig.name : btn.title
          }

          return btn
        })
        .filter(menu => menu.isDisplay)
    }
  },

  data () {
    return {
      btns: [
        {
          title: 'Download Full Entry Kit',
          key: 'downloadFullEntryKit',
          link: ''
        },
        {
          title: 'Download Client Endorsement Form',
          key: 'downloadClientEndorsementForm',
          link: ''
        }
      ]
    }
  },

  methods: {
    clickToDetail (id) {
      this.$store.dispatch('awards/getCateDetail', id)

      this.$router.push({
        name: 'category-detail',
        params: {
          id: id
        }
      })
    },

    matchLinkBtn (data) {
      data.forEach(item => {
        this.btns[0].link = `${this.baseURL}/storage/app/pdf/award/${item.link1}`
        this.btns[1].link = `${this.baseURL}/storage/app/pdf/award/${item.link2}`
      })
    }
  },

  created () {
    if (this.links) {
      this.matchLinkBtn(this.links)
    }
  },

  watch: {
    links (data) {
      this.matchLinkBtn(data)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.wrap-category {
  padding: 22px;

  .box-btn {
    .col {
      margin-bottom: 12px;

      a {
        div {
          padding: 12px 0;
          border-bottom: 3px solid #58595B;
          background-color: #C4C5C5;
          text-align: center;
          font-size: 1.25rem;
          color: white;
        }

        div:hover {
          background-color: #DA0401;
        }
      }
    }
  }
}
</style>
